import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { OmitPaginatedEndpointParams } from '../../types';
import { FindConsultantsParams } from './consultants.types';

export const getFindConsultantsKey = (params: FindConsultantsParams): UseDataQuery['queryKey'] => [
  DataQueryKey.CONSULTANTS,
  undefined,
  params ?? {},
];

export const getInfiniteConsultantsKey = (
  params: OmitPaginatedEndpointParams<FindConsultantsParams>,
): UseDataQuery['queryKey'] => [DataQueryKey.CONSULTANTS, undefined, params ?? {}];
